import { Button, Popover, Select, Space } from "antd";

import styles from "./index.module.less";
import { useUserProfile } from "./index.hook";
import Auxiliary from "../../../../util/Auxiliary";
import { General } from "../../../../util/General";
import { useLocation } from "react-router-dom";
import { SideMenuItemKeys } from "../../../../constants/ApplicationConstants/RouteConstants";
import { allowedCustomerDropdownList, allowedDropdownList, allowedLocationDropdownList } from "../../../../constants/ApplicationConstants/MasterConstant";
import { Modules } from "../../../../constants/DatabaseConstants/MasterConstant";

const UserProfile = () => {
  /* CONSTANTS */
  const location = useLocation();
  const config = useUserProfile();

  const pathSegments = location.pathname?.split("/");
  const segment1 = pathSegments[1] as SideMenuItemKeys;
  const segment2 = pathSegments[2] as Modules;

  const userMenuOptions = (
    <ul className="gx-user-popover">
      {/* <li onClick={config.handleAbout}>About</li> */}
      <li onClick={config.handleLogOut}>Logout</li>
    </ul>
  );

  return (
    <ul className="gx-header-notifications gx-ml-auto">
      <Auxiliary>
        {/* Allowed routes path show filters */}
        {pathSegments && allowedDropdownList?.includes(segment1) && (
          <li className={styles["dropdown-container"]}>
            {allowedCustomerDropdownList?.includes(segment2) && (
              <div className={styles["location-dropdown"]}>
                <span className={styles["dropdown_label"]}>Customer</span>
                <Select showSearch value={config.customerId} listHeight={200} onChange={config.handleChangeCustomer} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} className={styles["dropdown__selector"]} placeholder="Select Customer">
                  {config.customerList?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.customer_name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            {allowedLocationDropdownList?.includes(segment2) && (
              <div className={styles["location-dropdown"]}>
                <span className={styles["dropdown_label"]}>Location</span>
                <Select showSearch allowClear value={config.locationId} listHeight={200} onChange={config.handleChangeLocation} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} className={styles["dropdown__selector"]} placeholder="Select Location">
                  {config.locationList?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.location_name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            {/* <div className={styles["client-dropdown"]}>
            <span className={styles["dropdown_label"]}>Client</span>
            <Select showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }} filterOption={General.searchFilterOnSelect} className={styles["dropdown__selector"]} placeholder="Select Client">
              {customerClientMasterList?.map((item) => (
                <Select.Option key={item.id} value={item.id} >
                  {item.client_name}
                </Select.Option>
              ))}
            </Select>
          </div> */}
          </li>
        )}

        <li className="gx-user-nav">
          <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={userMenuOptions} trigger="click" open={config.open} onOpenChange={config.handleOpenChange}>
            <Space>
              <Button type="primary" className="gx-size-40 gx-mb-0 gx-mr-1 gx-fs-lg" shape="circle">
                {config.userData?.first_name?.charAt(0).toUpperCase() ?? ""}
                {config.userData?.last_name?.charAt(0).toUpperCase() ?? ""}
              </Button>

              <span className={`${styles["gx-avatar-name"]} h3`}>
                {config.userData?.first_name} {config.userData?.last_name}
              </span>
            </Space>
          </Popover>
        </li>
      </Auxiliary>
    </ul>
  );
};

export default UserProfile;
